/**
 * Vimeo URL helpers for coach admin embeds.
 * Mirrors the main app's lib/services/vimeo.ts embed parsing.
 */

export function extractVimeoId(url) {
  if (!url) return null;
  const match = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return match ? match[1] : null;
}

export function extractVimeoPrivacyHash(url) {
  if (!url) return null;

  const queryMatch = String(url).match(/[?&]h=([^&]+)/);
  if (queryMatch?.[1]) return queryMatch[1];

  const pathMatch = String(url).match(/vimeo\.com\/(?:video\/)?\d+\/([a-f0-9]+)/i);
  return pathMatch?.[1] ?? null;
}

export function buildVimeoWebEmbedUrl(vimeoId, params = {}, privacyHash) {
  const searchParams = new URLSearchParams();

  if (privacyHash) {
    searchParams.set('h', privacyHash);
  }

  for (const [key, value] of Object.entries(params)) {
    searchParams.set(
      key,
      typeof value === 'boolean' ? (value ? '1' : '0') : String(value)
    );
  }

  return `https://player.vimeo.com/video/${vimeoId}?${searchParams.toString()}`;
}

export function pickBestMp4File(files) {
  if (!Array.isArray(files) || files.length === 0) return null;

  const mp4Files = files.filter(
    (file) => file?.type === 'video/mp4' && file?.quality !== 'hls' && file?.link
  );

  if (mp4Files.length === 0) return null;

  const preferredQualities = ['720p', '540p', '1080p', '360p'];
  for (const quality of preferredQualities) {
    const match = mp4Files.find((file) => file.public_name === quality);
    if (match) return match;
  }

  return mp4Files.find((file) => file.quality === 'hd') ?? mp4Files[0];
}

export function getPortraitPlayerSize(width = 320, aspectWidth = 9, aspectHeight = 16) {
  return {
    width,
    height: Math.round(width * (aspectHeight / aspectWidth)),
  };
}
